export default {
  dimensions: [],
  dimension: undefined,
};
